import React from "react";
import { motion } from "framer-motion";
import stratigic from "../Images/stratigic.png";
import referral from "../Images/referral.png";
import technology from "../Images/technology.png";
import channel from "../Images/channel.png";

const steps = [
  {
    id: 1,
    title: "Strategic Alliance",
    description:
      "Form strategic partnerships to combine our complementary strengths and deliver comprehensive solutions to clients.",
    color: "bg-orange-400",
    iconImg: stratigic,
    textColor: "text-[#FF927B]",
  },
  {
    id: 2,
    title: "Referral Partnership",
    description:
      "Refer clients to each other and earn commissions on successful referrals that convert into projects.",
    color: "bg-pink-500",
    iconImg: referral,
    textColor: "text-[#FF4FE4]",
  },
  {
    id: 3,
    title: "Technology Partnership",
    description:
      "Integrate our technologies to create innovative solutions that address complex business challenges.",
    color: "bg-teal-400",
    iconImg: technology,
    textColor: "text-[#68F1D8]",
  },
  {
    id: 4,
    title: "Channel Partnership",
    description:
      "Resell our services and solutions to clients, expanding your offering without additional overhead.",
    color: "bg-green-400",
    iconImg: channel,
    textColor: "text-[#B7E333]",
  },
];

// Duplicate elements for infinite effect
const marqueeSteps = [...steps, ...steps];

export default function PartnershipModels() {
  return (
    <div className="flex relative flex-col   overflow-hidden bg-gray-900 text-white">
      {/*  */}
      <div className="p-5 md:ml-15 mt-5">
        <button className="w-[270px] h-[60px] relative rounded-full bg-[#432DD7]">
          Partnership Models
        </button>
        <h2
          className="text-[30px] md:text-[40px] font-[700] relative"
          style={{ fontFamily: "PT Sans" }}
        >
          Flexible partnership models
        </h2>
        <h2 className="text-[30px] md:text-[40px] font-[400] relative font-[Allison]">
          tailored for collaboration, growth, and business success.
        </h2>
        <h2 className="text-[16px] font-[400]  max-w-[1200px]">
          Explore our flexible partnership models designed to create mutual
          growth opportunities and long-term success. Whether you're a startup
          or an established enterprise, our tailored collaboration approaches
          ensure scalability, innovation, and seamless integration. Partner with
          us to drive efficiency, innovation, and sustainable business growth.
        </h2>
      </div>
      {/* Infinite Scrolling Cards */}
      <div className="w-full overflow-hidden relative mt-10 mb-10">
        <motion.div
          className="flex gap-8"
          animate={{ x: ["0%", "-100%"] }} // Move content infinitely
          transition={{
            ease: "linear",
            duration: 15,
            repeat: Infinity,
          }}
        >
          {[...marqueeSteps, ...marqueeSteps].map((step, index) => (
            <div
              key={index}
              className="min-w-[280px] md:min-w-[320px] lg:min-w-[350px] flex flex-col p-6 rounded-lg bg-[#FFFFFF33] border border-white"
            >
              {/* Dots Above Cards */}
              <div className="absolute top-[-16px] left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-600 rounded-full"></div>

              {/* Colored Icon Background */}

              <img
                src={step.iconImg}
                alt={step.title}
                className="w-20 h-20 object-contain"
              />

              {/* Title with Matching Color */}
              <h3
                className={`mt-4 text-xl font-bold ${step.textColor}`}
                style={{ fontFamily: "PT Sans" }}
              >
                {step.title}
              </h3>

              {/* Description */}
              <p className="mt-2 leading-relaxed max-w-[280px] text-white break-words text-wrap text-left">
                {step.description}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
